import isEqual from 'lodash/fp/isEqual';

import { ProjectPlayerBlockProps } from '..';

export default (prev: ProjectPlayerBlockProps, next: ProjectPlayerBlockProps) => isEqual(prev, next);
